/**
 * Where a finished comparison goes.
 *
 * The server stores every run and answers with its id, for signed-in
 * accounts and anonymous devices alike (the anonymous rows carry the
 * device's fingerprint for the admin activity view). The stored result's
 * page, /compare/h/[id], replays through /api/history/compare/[id], which
 * answers only the signed-in owner. So the permalink is for accounts;
 * an anonymous device sees its result inline on /compare, with the
 * inputs in the URL (2026-10-23: an anonymous visitor was sent to the
 * permalink and met "sign in to view").
 */
export type CompareResultTarget = { kind: "replay"; href: string } | { kind: "inline" };

export function compareResultTarget(
  data: { compare_history_id?: number | null; trace_id?: string | null },
  signedIn: boolean,
): CompareResultTarget {
  if (!signedIn || !data.compare_history_id) return { kind: "inline" };
  const qs = data.trace_id ? `?trace=${encodeURIComponent(data.trace_id)}` : "";
  return { kind: "replay", href: `/compare/h/${data.compare_history_id}${qs}` };
}
